"use client";
import { Unpacked } from "@/lib/types/global-types";
import React from "react";
import { TGetLewboardGeneration } from "../../b2c-api/src/routers/lewkboards";
import { useRouter } from "@/lib/utils/router-events";
import { Routes_Dashboard } from "@/config/page-routes";
import { cn } from "@/lib/utils/global-utils";
import Image from "next/image";

interface LewkboardItemProps
  extends Unpacked<TGetLewboardGeneration>,
    Omit<React.HTMLAttributes<HTMLDivElement>, "id"> {
  index: number;
  size?: string;
  genID?: number;
  selected?: boolean;
}
const LewkItem = React.forwardRef<HTMLDivElement, LewkboardItemProps>(
  (
    { id, index, images, className, size, genID, onClick, selected, ...rest },
    ref
  ) => {
    const router = useRouter();

    return (
      <div
        {...rest}
        ref={ref}
        onClick={
          onClick
            ? onClick
            : () => {
                !selected &&
                  router.push(
                    `${Routes_Dashboard.LEWKBOARD_VIEW}/${id}?index=${index}${genID ? `&genID=${genID}` : ""}`
                  );
              }
        }
        className={cn(
          " cursor-pointer flex-shrink-0 text-center hover:scale-105 transition-all",
          className
        )}
      >
        <div
          className={cn(
            " rounded-base overflow-clip size-[161px] lg:size-[200px] grid grid-cols-2 grid-rows-2 ",
            size
          )}
        >
          {images.map((image, index) => (
            <div key={index} className=" relative">
              <Image
                src={image}
                className=" object-cover object-top"
                fill
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                alt={"Lewk Image " + index}
                unoptimized
              />
            </div>
          ))}
        </div>
        <h2 className=" text-base mt-2">{`LEWK ${index}`}</h2>
      </div>
    );
  }
);

export default LewkItem;
